import React from 'react';
import { Drawer } from 'antd';
import type { DrawerStyles } from 'antd/es/drawer/DrawerPanel';
import SidebarContent from '../Sidebar/SidebarContent';
import styles from './MobileDrawer.module.scss';
import logo from '../../logo.svg';

interface MobileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  selectedKeys: string[];
  onMenuClick: ({ key }: { key: string }) => void;
}

const drawerSafeStyles: DrawerStyles = {
  content: {
    paddingTop: 'env(safe-area-inset-top, 0px)',
    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    paddingLeft: 'env(safe-area-inset-left, 0px)',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    background: '#000000',
  },
  header: {
    background: '#000000',
    borderBottom: '0.5px solid var(--app-divider-color)',
    padding: '16px 24px',
    flexShrink: 0,
  },
  body: {
    padding: 0,
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    background: '#000000',
  },
};

const MobileDrawer: React.FC<MobileDrawerProps> = ({
  isOpen,
  onClose,
  selectedKeys,
  onMenuClick
}) => {
  return (
    <Drawer
      destroyOnClose
      closable={false}
      title={
        <div className={styles.drawerHeader}>
          <img src={logo} alt="logo" className={styles.logoImg} />
          <button
            type="button"
            aria-label="Close menu"
            className={styles.closeButton}
            onClick={onClose}
          >
            <img src="/layout.svg" alt="close" width={20} height={20} />
          </button>
        </div>
      }
      placement="left"
      onClose={onClose}
      open={isOpen}
      width={250}
      className={styles.mobileDrawer}
      rootClassName="app-mobile-drawer"
      styles={drawerSafeStyles}
    >
      <SidebarContent
        embedInDrawer
        selectedKeys={selectedKeys}
        onMenuClick={onMenuClick}
      />
    </Drawer>
  );
};

export default MobileDrawer; 